import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"background-color":"#eceff7"} }
const _hoisted_2 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_3 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_4 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_5 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_6 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  id: "myChart7",
  style: { width: '100%', height: '400px', backgroundColor: 'white' }
}, null, -1)
const _hoisted_8 = { style: {"font-size":"16px","font-weight":"100","background-color":"white","display":"flex","justify-content":"center","height":"40px"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","font-size":"18px"} }, "看直/复播超", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","font-size":"18px"} }, "分钟的客户", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  id: "myChart8",
  style: { width: '100%', height: '360px', backgroundColor: 'white' }
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  id: "myChart9",
  style: { width: '100%', height: '400px', backgroundColor: 'white' }
}, null, -1)

import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import localCache from '@/utils/cache'
import { ElLoading } from 'element-plus'
import type { FormInstance} from 'element-plus'
import * as echarts from 'echarts'
import {
  getLotteryData,
  getLiveFuboData,
  getliveFuboDealData
} from '@/service/main/inspect/ResourceAnalysis'

export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceLiveFubo',
  setup(__props) {

const store = useStore()
const shortcuts = [
  {
    text: '最近7天',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 7)
      return [start, end]
    }
  },
  {
    text: '最近1个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 1)
      return [start, end]
    }
  },
  {
    text: '最近3个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 3)
      return [start, end]
    }
  }
]
const formRef = ref<FormInstance>(null);
const queryParam = ref({
  timeSlot: ref<[string, string]>([
    dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ]),
  deptId: ref(''),
  empName: ref('')
})

const handleResetClick = () => {
  queryParam.value = {
    timeSlot: [
      dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ],
    deptId: '',
    empName: ''
  };
}

const resourceCount = ref(0)
const dealCount = ref(0)
const dealAmount = ref(0)
const lotteryDealCustNum = ref(0)
const lotteryDealAmount = ref(0)
const mins = [
  {
    value: '5',
    label: '5',
  },
  {
    value: '10',
    label: '10',
  },
  {
    value: '30',
    label: '30',
  },
]
const currmins = ref('5')
const liveFubo10CustNum = ref(0)
const liveFubo30CustNum = ref(0)
const liveFubo5CustNum = ref(0)
let myChart7: echarts.ECharts | null = null;
let myChart8: echarts.ECharts | null = null;
let myChart9: echarts.ECharts | null = null;
// let myChart11 = null;
// let myChart12 = null;

const updateChart8 = async () => {
  if (myChart8) {
    const n = "看直/复播超" + currmins.value + "分钟的客户数"
    const v = currmins.value == '5' ? liveFubo5CustNum.value :
      currmins.value == '10' ? liveFubo10CustNum.value :
        currmins.value == '30' ? liveFubo30CustNum.value : 0
    const s = resourceCount.value
    myChart8.setOption({ // 更新图表配置项中的数据部分
      // title: { text: '看直播超过xx分钟客户数' + data5.liveFubo5CustNum  },
      series: [{ data: [{ value: v, name: n }, { value: s - v, name: '其他' }] }]
    });
  }
}

const option7 = {
  tooltip: {
    formatter: '{b}: {c}' // {a}: 系列名, {b}: 数据名, {c}: 数据值
  },
  title: {
    text: '看直播/复播客户数',
    left: 'center',
    // top: '6%', // 标题距离容器顶部2%的位置
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '看直播/复播客户数'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['45%', '75%'],
      label: {
        show: true, // 显示所有标签
        position: 'inside', // 或者'outside', 'inside', 'top', 'left', 'right', 'bottom'
        formatter: function (params) {
          var maxLength = 5; // 设置最大显示长度
          var value = params.name;
          if (value.length > maxLength) {
            return value.substring(0, maxLength) + '...' + params.percent + '%';
          } else {
            return value + params.percent + '%';
          }
        } // 格式化标签内容，{b}是名称，{c}是值，{d}%是占比
      },
      labelLine: {
        show: false // 不显示连接线
      }
    }
  ]
}
const option8 = {
  tooltip: {
    formatter: '{b}: {c}' // {a}: 系列名, {b}: 数据名, {c}: 数据值
  },
  // title: {
  //   text: '看直播/复播超过XX分钟的客户数',
  //   left: 'center',
  //   top: '6%', // 标题距离容器顶部2%的位置
  // },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '看直播/复播超过XX分钟的客户数'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['52%', '83%'],
      label: {
        show: true, // 显示所有标签
        position: 'inside', // 或者'outside', 'inside', 'top', 'left', 'right', 'bottom'
        formatter: function (params) {
          var maxLength = 5; // 设置最大显示长度
          var value = params.name;
          if (value.length > maxLength) {
            return value.substring(0, maxLength) + '...' + params.percent + '%';
          } else {
            return value + params.percent + '%';
          }
        } // 格式化标签内容，{b}是名称，{c}是值，{d}%是占比
      },
      labelLine: {
        show: false // 不显示连接线
      }
    }
  ]
}
const option9 = {
  tooltip: {
    formatter: '{b}: {c}' // {a}: 系列名, {b}: 数据名, {c}: 数据值
  },
  title: {
    text: '成交客户看直播/复播',
    left: 'center',
    // top: '6%', // 标题距离容器顶部2%的位置
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: '成交客户看直播/复播'
        },
        {
          value: 0,
          name: '其他'
        }
      ],
      radius: ['45%', '75%'],
      label: {
        show: true, // 显示所有标签
        position: 'inside', // 或者'outside', 'inside', 'top', 'left', 'right', 'bottom'
        formatter: function (params) {
          var maxLength = 5; // 设置最大显示长度
          var value = params.name;
          if (value.length > maxLength) {
            return value.substring(0, maxLength) + '...' + params.percent + '%';
          } else {
            return value + params.percent + '%';
          }
        } // 格式化标签内容，{b}是名称，{c}是值，{d}%是占比
      },
      labelLine: {
        show: false // 不显示连接线
      }
    }
  ]
}
// const option11 = {
//   tooltip: {
//     formatter: '{b}: {c}' // {a}: 系列名, {b}: 数据名, {c}: 数据值
//   },
//   title: {
//     text: '抽奖成交额',
//     left: 'center',
//     // top: '6%', // 标题距离容器顶部2%的位置
//   },
//   series: [
//     {
//       type: 'pie',
//       data: [
//         {
//           value: 0,
//           name: '抽奖成交额'
//         },
//         {
//           value: 0,
//           name: '其他'
//         }
//       ],
//       radius: ['45%', '75%'],
//       label: {
//         show: true, // 显示所有标签
//         position: 'inside', // 或者'outside', 'inside', 'top', 'left', 'right', 'bottom'
//         formatter: '{b}: {d}%' // 格式化标签内容，{b}是名称，{c}是值，{d}%是占比
//       },
//       labelLine: {
//         show: false // 不显示连接线
//       }
//     }
//   ]
// }
// const option12 = {
//   tooltip: {
//     formatter: '{b}: {c}' // {a}: 系列名, {b}: 数据名, {c}: 数据值
//   },
//   title: {
//     text: '抽奖成交客户数',
//     left: 'center',
//     // top: '6%', // 标题距离容器顶部2%的位置
//   },
//   series: [
//     {
//       type: 'pie',
//       data: [
//         {
//           value: 0,
//           name: '抽奖成交客户数'
//         },
//         {
//           value: 0,
//           name: '其他'
//         }
//       ],
//       radius: ['45%', '75%'],
//       label: {
//         show: true, // 显示所有标签
//         position: 'inside', // 或者'outside', 'inside', 'top', 'left', 'right', 'bottom'
//         formatter: function (params) {
//           var maxLength = 5; // 设置最大显示长度
//           var value = params.name;
//           if (value.length > maxLength) {
//             return value.substring(0, maxLength) + '...' + params.percent + '%';
//           } else {
//             return value + params.percent + '%';
//           }
//         } // 格式化标签内容，{b}是名称，{c}是值，{d}%是占比
//       },
//       labelLine: {
//         show: false // 不显示连接线
//       }
//     }
//   ]
// }

const initData = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '统计数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  const [data4, data5, data7] = await Promise.allSettled([
    getLotteryData(queryParam.value),
    getLiveFuboData(queryParam.value),
    getliveFuboDealData(queryParam.value)
  ])
  loadingInstance.close()
  if (data4.status == 'fulfilled') {
    dealCount.value = data4.value.dealCount
    dealAmount.value = data4.value.dealAmount
    resourceCount.value = data4.value.resourceCount
    lotteryDealAmount.value = data4.value.lotteryDealAmount
    lotteryDealCustNum.value = data4.value.lotteryDealCustNum
    // if (myChart11) {
    //   myChart11.setOption({ // 更新图表配置项中的数据部分
    //     title: { text: '抽奖成交额' + data4.value.lotteryDealAmount },
    //     series: [{ data: [{ value: data4.value.lotteryDealAmount, name: '抽奖成交额' }, { value: data4.value.dealAmount - data4.value.lotteryDealAmount, name: '其他' }] }]
    //   });
    // }
    // if (myChart12) {
    //   myChart12.setOption({ // 更新图表配置项中的数据部分
    //     title: { text: '抽奖成交客户数' + data4.value.lotteryDealCustNum },
    //     series: [{ data: [{ value: data4.value.lotteryDealCustNum, name: '抽奖成交客户数' }, { value: data4.value.dealCount - data4.value.lotteryDealCustNum, name: '其他' }] }]
    //   });
    // }
  } else {
    // if (myChart11) {
    //   myChart11.setOption(option11)
    // }
    // if (myChart12) {
    //   myChart12.setOption(option12)
    // }
  }
  if (data5.status == 'fulfilled') {
    if (myChart7) {
      myChart7.setOption({ // 更新图表配置项中的数据部分
        title: { text: '看直播/复播客户数' + data5.value.liveFuboCustNum },
        series: [{ data: [{ value: data5.value.liveFuboCustNum, name: '看直播/复播客户数' }, { value: data5.value.resourceCount - data5.value.liveFuboCustNum, name: '其他' }] }]
      });
    }
    if (myChart8) {
      liveFubo5CustNum.value = data5.value.liveFubo5CustNum
      liveFubo10CustNum.value = data5.value.liveFubo10CustNum
      liveFubo30CustNum.value = data5.value.liveFubo30CustNum
      const n = "看直/复播超" + currmins.value + "分钟的客户数"
      myChart8.setOption({ // 更新图表配置项中的数据部分
        // title: { text: '看直播超过xx分钟客户数' + data5.liveFubo5CustNum  },
        series: [{ data: [{ value: data5.value.liveFubo5CustNum, name: n }, { value: data5.value.resourceCount - data5.value.liveFubo5CustNum, name: '其他' }] }]
      });
    }
  } else {
    if (myChart7) {
      myChart7.setOption(option7)
    }
    if (myChart8) {
      myChart8.setOption(option8)
    }
  }
  if (data7.status == 'fulfilled') {
    if (myChart9) {
      myChart9.setOption({ // 更新图表配置项中的数据部分
        title: { text: '成交客户看直播/复播' + data7.value.liveFuboDealCustNum },
        series: [{ data: [{ value: data7.value.liveFuboDealCustNum, name: '成交客户看直播复播' }, { value: data7.value.dealCount - data7.value.liveFuboDealCustNum, name: '其他' }] }]
      });
    }
  } else {
    if (myChart9) {
      myChart9.setOption(option9)
    }
  }
}

const handleResize = () => {
  myChart7?.resize()
  myChart8?.resize()
  myChart9?.resize()
}

onMounted(() => {
  initData()
  myChart7 = echarts.init(document.getElementById('myChart7'))
  myChart7.setOption(option7)
  myChart8 = echarts.init(document.getElementById('myChart8'))
  myChart8.setOption(option8)
  myChart9 = echarts.init(document.getElementById('myChart9'))
  myChart9.setOption(option9)
  // myChart11 = echarts.init(document.getElementById('myChart11'))
  // myChart11.setOption(option11)
  // myChart12 = echarts.init(document.getElementById('myChart12'))
  // myChart12.setOption(option12)

  window.addEventListener('resize', handleResize)
  // window.addEventListener('resize', function () {
  //   myChart11.resize();
  // });
  // window.addEventListener('resize', function () {
  //   myChart12.resize();
  // });
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
  myChart7?.dispose()
  myChart8?.dispose()
  myChart9?.dispose()
  myChart7 = null
  myChart8 = null
  myChart9 = null
})
const rules = {
  timeSlot: [{
    required: true,
    message: '加入时间必填',
    trigger: 'change',
  }],
}

const userOptions = localCache.getCache('empData').map((item: any) => {
  return { title: item.realName, value: item.realName }
})

const deptOptions = store.state.login.depts.map((item: any) => {
  return { title: item.name, value: item.id }
})

const onSubmit = async (formRef: FormInstance) => {
  if (!formRef) return
  await formRef.validate((valid, fields) => {
    if (valid) {
      console.log('校验成功')
      initData()
    } else {
      console.log('校验失败')
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      inline: true,
      model: queryParam.value,
      class: "demo-form-inline",
      rules: rules,
      style: {"padding":"10px 0 0","background-color":"#fff"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "组别" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryParam.value.deptId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParam.value.deptId) = $event)),
                      placeholder: "请选择组别",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deptOptions), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.title,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      onClick: handleResetClick
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onSubmit(formRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("搜索")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 7 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg,rgba(145, 204, 117, 1), rgba(145, 204, 117, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("资源开单数"),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(dealCount.value), 1),
                    _createTextVNode("（个）")
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(250, 200, 88, 1), rgba(250, 200, 88, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("资源成交金额"),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(dealAmount.value), 1),
                    _createTextVNode("（元）")
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(84, 112, 198, 1), rgba(84, 112, 198, 0.5))","margin-bottom":"10px","margin-top":"128px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("资源总数"),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(resourceCount.value), 1),
                    _createTextVNode("（个）")
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg,rgba(145, 204, 117, 1), rgba(145, 204, 117, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("抽奖成交客户数"),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(lotteryDealCustNum.value), 1),
                    _createTextVNode("（个）")
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(250, 200, 88, 1), rgba(250, 200, 88, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("抽奖成交额"),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(lotteryDealAmount.value), 1),
                    _createTextVNode("（元）")
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 7 }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1,
            style: {"position":"relative","background-color":"#fff"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_el_select, {
                  modelValue: currmins.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currmins).value = $event)),
                  class: "m-2",
                  placeholder: "Select",
                  size: "small",
                  style: {"width":"60px"},
                  onChange: updateChart8
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mins, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_10
              ]),
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})